import { render, staticRenderFns } from "./AddCustomFieldModal.vue?vue&type=template&id=0d98f7d3"
import script from "./AddCustomFieldModal.vue?vue&type=script&lang=ts"
export * from "./AddCustomFieldModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports